import React, { useState, useEffect } from 'react';
import useSWR, { mutate } from 'swr';
import { useParams } from 'react-router-dom';
import { Form, Button, Card, Modal, Spinner, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import api from '../../../services/api';
import { congenito as dbcongenito } from '../../../helpers/laudos/congenito';
import CustomFileInput from '../../../components/CustomFileInput';
import { liberarLaudoByPac } from '../../../services/prontuario';
import useUploadFiles from '../../../hooks/useUploadFiles';
import useViewFiles from '../../../hooks/useViewFiles';
import generateCongTXTPDF from './generateCongTXTPDF';
import FontScaleButtonGroup from '../../../components/FontScaleButtonGroup';
import Footer from '../../../components/laudos/Footer';
import FileCarousel from '../../../components/laudos/FileCarousel';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';
import selectEcoById from '../../../services/ecodoppler';
import ModalEco from './ModalEco';
import useIsMedicoExterno from '../../../hooks/useIsMedicoExterno';
import { formatarIdadeMeses } from '../../../util/utils';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function FormCongenitoTXT() {
  const { id } = useParams();
  const { data: eco, error, isLoading } = useSWR(id ? ['eco', id] : null, () =>
    selectEcoById(id)
  );
  const isMedicoExterno = useIsMedicoExterno();
  const [ecoLaudo, setEcoLaudo] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // NOVO: Estado para quebra de página ('aorta' | 'coronarias' | 'conclusao' | 'sem')
  const [quebraPagina, setQuebraPagina] = useState('sem');

  useEffect(() => {
    if (eco) {
      setEcoLaudo({
        ...eco,
        CODECO: eco?.CODECO || '',
        TIPOCONGENITO: eco?.TIPOCONGENITO || '',
        TIPOECO: eco?.TIPOECO || '',
        TIPOLAUDO: eco?.TIPOLAUDO || '',
        OBSERVACOES: eco?.OBSERVACOES || '',
      });
    }
  }, [eco]);

  const [fontScale, setFontScale] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const {
    urls,
    setURLs,
    loadingFiles,
    showModal: showFilesModal,
    setShowModal: setShowFilesModal,
    showFiles,
  } = useViewFiles({ codLaudo: eco?.CODECO, procedimento: 'eco' });

  const {
    files,
    setFiles,
    showUpload,
    setShowUpload,
    isUploading,
    confirmUpload,
    handleCloseModal,
  } = useUploadFiles({ atividade: eco });

  const handleTIPOECO = tipo => {
    let observacoes = '';
    switch (tipo) {
      case 'normal':
        observacoes = dbcongenito[0].normal;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'civ':
        observacoes = dbcongenito[1].civ;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (CIV)',
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'fop':
        observacoes = dbcongenito[2].fop;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (FOP)',
        });
        document.getElementById('editDescricao').focus();
        break;
      case 't4f':
        observacoes = dbcongenito[3].t4f;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (T4F)',
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'pca':
        observacoes = dbcongenito[4].pca;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (PCA)',
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'cia':
        observacoes = dbcongenito[5].cia;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (CIA)',
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'tga':
        observacoes = dbcongenito[6].tga;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (TGA)',
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'dsavt':
        observacoes = dbcongenito[7].dsavt;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (DSAVT)',
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'coao':
        observacoes = dbcongenito[8].coao;
        setEcoLaudo({
          ...ecoLaudo,
          OBSERVACOES: observacoes,
          TIPOCONGENITO: 'ECODOPPLERCARDIOGRAMA CONGÊNITO (COAO)',
        });
        document.getElementById('editDescricao').focus();
        break;
      default:
    }
  };

  const handleGravar = async (event, tipo) => {
    event.preventDefault();
    try {
      setIsSubmitting(true);
      const res = await api.put(`/ecocardiograma/${ecoLaudo.CODECO}`, ecoLaudo);
      if (tipo === 'definitivo') {
        const fatura = { codLaudo: ecoLaudo.CODECO, codPac: ecoLaudo.CODPAC };
        await liberarLaudoByPac({ fatura });
        toast.success(res.data.message);
        mutate(['eco', id]);
        return;
      }
      toast.success(res.data.message);
      mutate(['eco', id]);
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro ao gravar laudo!');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (error) {
    return (
      <Alert variant="danger" style={{ marginTop: 10 }}>
        <Alert.Heading>Erro ao carregar laudo de eco!</Alert.Heading>
        <p>Tente novamente.</p>
      </Alert>
    );
  }

  if (isLoading || !ecoLaudo) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <Spinner animation="border" variant="dark" size="lg" />
      </div>
    );
  }

  return (
    <>
      <Card className="mt-2">
        <LaudoCardHeader title="ECOCARDIOGRAMA CONGÊNITO" />
        {!isMedicoExterno && (
          <div
            className="d-flex justify-content-between align-items-center w-100"
            style={{ padding: '8px 16px 0 16px', gap: '16px' }}
          >
            {/* Grupo do Tipo Eco (Alinhado à esquerda) */}
            <div className="d-flex align-items-center" style={{ gap: '16px' }}>
              <Form.Label className="mb-0 font-weight-bold" style={{ whiteSpace: 'nowrap' }}>
                Tipo Eco:
              </Form.Label>
              <Form.Check
                inline
                label="Doppler"
                name="groupTipoEco"
                type="radio"
                id="EcoD"
                checked={ecoLaudo.TIPOECO === 'EcoD'}
                onChange={() => setEcoLaudo({ ...ecoLaudo, TIPOECO: 'EcoD' })}
                className="mb-0"
              />
              <Form.Check
                inline
                label="Congênito"
                name="groupTipoEco"
                type="radio"
                id="EcoC"
                checked={ecoLaudo.TIPOECO === 'EcoC'}
                onChange={() => setEcoLaudo({ ...ecoLaudo, TIPOECO: 'EcoC' })}
                className="mb-0"
              />
            </div>

            {/* Botão Copiar (Alinhado à direita) */}
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => setShowModal(true)}
              className="d-flex align-items-center"
              style={{ whiteSpace: 'nowrap' }}
            >
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-2"
              >
                <path d="M10 1.5A1.5 1.5 0 0 1 11.5 3v1h-7V3A1.5 1.5 0 0 1 6 1.5h4zm1.5 2A.5.5 0 0 0 11 3V1.5A2.5 2.5 0 0 0 8.5-1h-4A2.5 2.5 0 0 0 2 1.5V3a.5.5 0 0 0-.5.5v10A2.5 2.5 0 0 0 4 16h8a2.5 2.5 0 0 0 2.5-2.5v-10A.5.5 0 0 0 14 3V1.5A1.5 1.5 0 0 0 12.5 0h-4A1.5 1.5 0 0 0 7 1.5V3a.5.5 0 0 0-.5.5v10A1.5 1.5 0 0 0 8 15h4a1.5 1.5 0 0 0 1.5-1.5v-10z" />
              </svg>
              Copiar Laudo Anterior
            </Button>
          </div>
        )}
        <hr />
        <Card.Body style={{ margin: '0px 0px 0 0px' }}>
          <Form noValidate>
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${ecoLaudo.CODPAC} - ${ecoLaudo.NOMEPAC}`}
            <br />
            <strong className="mr-auto">Data de Nasc: </strong>
            {`${ecoLaudo.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Sexo: </strong>
            {`${ecoLaudo.Sexo}`}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {`${ecoLaudo.DTNPAC ? formatarIdadeMeses(ecoLaudo?.DTNPAC, ecoLaudo?.DATAECO) : '--'}`}
            <br />
            <strong className="mr-auto">Convênio: </strong>
            {ecoLaudo.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Cod Laudo: </strong>
            {ecoLaudo.CODECO}&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {ecoLaudo.dataEcoFmt}
            <br />
            <strong className="mr-auto">Médico que Realizou: Dr. </strong>
            {`${ecoLaudo.Realizou}`}
            <br />
            <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
            {`${ecoLaudo.Solicitou}`}
            {!isMedicoExterno && (
              <>
                <Card className="p-2 mb-2 mt-2" style={{ fontSize: 12 }}>
                  <strong>TIPO DE LAUDO</strong>
                  <Form.Check
                    label="NORMAL"
                    name="groupTipoEco"
                    type="radio"
                    defaultChecked={ecoLaudo.TIPOLAUDO === 'Normal'}
                    id="Normal"
                    onClick={e =>
                      setEcoLaudo({ ...ecoLaudo, TIPOLAUDO: e.target.id })
                    }
                  />
                  <Form.Check
                    label="ALTERADO"
                    name="groupTipoEco"
                    type="radio"
                    defaultChecked={ecoLaudo.TIPOLAUDO === 'Alterado'}
                    id="Alterado"
                    onClick={e =>
                      setEcoLaudo({ ...ecoLaudo, TIPOLAUDO: e.target.id })
                    }
                  />

                </Card>
                <Card className="p-2 mb-2" style={{ fontSize: 12 }}>
                  <strong>TIPO DE ECO CONGÊNITO</strong>
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (NORMAL)"
                    name="groupFetal"
                    type="radio"
                    id="normal"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'normal'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (CIV)"
                    name="groupFetal"
                    type="radio"
                    id="civ"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'civ'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (FOP)"
                    name="groupFetal"
                    type="radio"
                    id="fop"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'fop'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (T4F)"
                    name="groupFetal"
                    type="radio"
                    id="t4f"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 't4f'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (PCA)"
                    name="groupFetal"
                    type="radio"
                    id="pca"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'pca'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (CIA)"
                    name="groupFetal"
                    type="radio"
                    id="cia"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'cia'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (TGA)"
                    name="groupFetal"
                    type="radio"
                    id="tga"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'tga'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (DSAVT)"
                    name="groupFetal"
                    type="radio"
                    id="dsavt"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'dsavt'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                  <Form.Check
                    label="ECODOPPLERCARDIOGRAMA CONGÊNITO (COAO)"
                    name="groupFetal"
                    type="radio"
                    id="coao"
                    defaultChecked={ecoLaudo.TIPOCONGENITO === 'coao'}
                    onClick={event => handleTIPOECO(event.target.id)}
                  />
                </Card>
              </>
            )}
            <Form.Group size="sm" controlId="editDescricao">
              <strong>DESCRIÇÃO</strong>
              <Form.Control
                as="textarea"
                rows={ecoLaudo?.OBSERVACOES?.split('\n').length + 3 || 2}
                name="DESCRICAO"
                value={ecoLaudo.OBSERVACOES ? ecoLaudo.OBSERVACOES : ''}
                readOnly={!!isMedicoExterno}
                onChange={e =>
                  setEcoLaudo({ ...ecoLaudo, OBSERVACOES: e.target.value })
                }
                onKeyDown={e => {
                  if (e.key === 'F2') {
                    const posStart = ecoLaudo.OBSERVACOES.indexOf('---');
                    const elem = document.getElementById('editDescricao');
                    elem.setSelectionRange(posStart, posStart + 3);
                  }
                }}
              />
            </Form.Group>
            {!isMedicoExterno && (
              <FontScaleButtonGroup
                fontScale={fontScale}
                setFontScale={setFontScale}
              />
            )}
            {/* NOVO: Bloco de Opções de Quebra de Página */}
            <Card className="p-2 mb-2" style={{ fontSize: 12, backgroundColor: '#f8f9fa' }}>
              <strong>QUEBRA DE PÁGINA (PDF):</strong>
              <div className="d-flex align-items-center mt-1">
                <Form.Check
                  inline
                  label="AORTA"
                  name="groupQuebraCongenito"
                  type="radio"
                  id="quebraAorta"
                  checked={quebraPagina === 'aorta'}
                  onChange={() => setQuebraPagina('aorta')}
                />
                <Form.Check
                  inline
                  label="ARTÉRIAS CORONÁRIAS"
                  name="groupQuebraCongenito"
                  type="radio"
                  id="quebraCoronarias"
                  checked={quebraPagina === 'coronarias'}
                  onChange={() => setQuebraPagina('coronarias')}
                />
                <Form.Check
                  inline
                  label="CONCLUSÃO"
                  name="groupQuebraCongenito"
                  type="radio"
                  id="quebraConclusao"
                  checked={quebraPagina === 'conclusao'}
                  onChange={() => setQuebraPagina('conclusao')}
                />
                <Form.Check
                  inline
                  label="SEM QUEBRA"
                  name="groupQuebraCongenito"
                  type="radio"
                  id="quebraSem"
                  checked={quebraPagina === 'sem'}
                  onChange={() => setQuebraPagina('sem')}
                />
              </div>
            </Card>
            <Footer
              gravarParcial={e => handleGravar(e, 'parcial')}
              gravarDefinitivo={e => handleGravar(e, 'definitivo')}
              isSubmitting={isSubmitting}
              imprimirPdfNormal={() =>
                generateCongTXTPDF(ecoLaudo, 'imprimirNormal', fontScale, quebraPagina)
              }
              imprimirPdfTimbrado={() =>
                generateCongTXTPDF(ecoLaudo, 'imprimirTimbrado', fontScale, quebraPagina)
              }
              enviarPorWpp={() =>
                generateCongTXTPDF(ecoLaudo, 'envioWpp', fontScale, quebraPagina)
              }
              verImagens={showFiles}
              abrirUploadModal={() => setShowUpload(true)}
              laudo={ecoLaudo}
            />
          </Form>
        </Card.Body>
      </Card>

      <ModalEco
        show={showModal}
        onHide={() => setShowModal(false)}
        codPac={eco?.CODPAC}
        onSelect={obs => {
          setEcoLaudo(prev => ({ ...prev, OBSERVACOES: obs }));
          setShowModal(false);
        }}
        onCopy={ecoSelected => {
          setEcoLaudo(prev => ({
            ...prev,
            OBSERVACOES: ecoSelected.OBSERVACOES || '',
            TIPOCONGENITO: ecoSelected.TIPOCONGENITO || '',
            TIPOLAUDO: ecoSelected.TIPOLAUDO || '',
          }));
          setShowModal(false);
        }}
      />

      <Modal
        show={showFilesModal}
        onHide={() => setShowFilesModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Imagens</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingFiles ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
              }}
            >
              <Spinner animation="border" variant="dark" size="lg" />
            </div>
          ) : (
            <FileCarousel urls={urls} setURLs={setURLs} />
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showUpload} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Anexar arquivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomFileInput
            id="file-upload"
            label="Selecionar arquivo"
            multiple={true}
            onChange={e => setFiles(Array.from(e.target.files))}
          />
          <ul>
            {files && files.map(({ name }) => <li key={name}>{name}</li>)}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          {isUploading ? (
            <Spinner animation="border" variant="dark" />
          ) : (
            <Button onClick={confirmUpload}>Confirmar</Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
